/* eslint-disable import/no-duplicates */
import { yupResolver } from '@hookform/resolvers/yup';
import { Add, Info, Remove, Search } from '@mui/icons-material';
import ErrorIcon from '@mui/icons-material/Error';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Tooltip,
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import {
  IAddCorrespondenceInputModel,
  IJobValuesUpdateInputModel,
  ISolicitationInputModel,
} from 'inputModels';
import { serialize } from 'object-to-formdata';
import { useEffect, useMemo, useState } from 'react';
import { Controller, useForm, useWatch, useFieldArray } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { ISolicitationDuplicatedViewModel } from 'viewModels';
//import CreatableSelect from 'react-select/creatable';
import { useTheme } from 'styled-components';
import { Attachment, BasicButton, DropZone, Input, NavHeader } from '../../components';
import CurrencyInput from '../../components/CurrencyInput';
import { DropDownList } from '../../components/DropDownList';
import { CustomFile } from '../../components/DropZone';
import {
  ATTACHMENT_TYPE_DESCRIPTIONS,
  BRAZILIAN_STATES,
  MASK_PROCESS_NUMBER,
  UF_BY_CODE,
  UF_CODE_BY_NAME,
  UF_KEYS,
  UF_NAMES_BY_CODE,
} from '../../constants';
import { useApp, useAuth } from '../../context';
import { useClients } from '../../context/clients';
import { useSolicitation } from '../../context/solicitation';
import { SolicitationController } from '../../controller/SolicitationController';
import { Download } from '../../controller/FileController';
import { useAlert } from '../../hooks/useAlert';
import { useGoogleEvents } from '../../hooks/useGoogleEvents';
import { AudienceType, CorrespondenceType, labelAudienceType, TutorialType, TypeUser } from '../../types/enums';
import { unMask } from '../../utils/removeMask';
import { slugify } from '../../utils/slugify';
import { Body, Container } from './styles';
import { useSpecialties } from '../../context/specialties';
import { useJobValues } from '../../context/jobvalues';
import { DropListDistricts } from '../../components/DropListDistricts';
import { useCourts } from '../../context/courts';
import { ModalDuplicateSolicitation } from '../../components/Modals/ModalDuplicateSolicitation';
import { useCorrespondences } from '../../context/correspondences';
import CorrespondenceController from '../../controller/CorrespondenceController';
import { UserController } from '../../controller/UserController';
import SolucionareController from '../../controller/SolucionareController';
import { useDistricts } from '../../context/districts';
import { CompanyController } from '../../controller/CompanyController';
import { DistrictController } from '../../controller/DistrictController';
import { getCodeByName } from '../../services/api/ibge';
import { extractPostalCode, GetAddressByGeocoding } from '../../services/maps';
import { changeSpaceToUnderline } from '../../utils/changeSpaceToUnderline';
import {
  buildAddressCacheKey,
  buildGeocodingAddressQueries,
  isValidAudienceNumberField,
  normalizeCityName,
  parseAddressNumber,
} from '../../utils/addressNumber';
import { useConfig } from '../../context/configCustom';
import { useDebounce } from '../../hooks/useDebounce';
import TitlePage from '../../components/TitlePage';
import JoyrideTour from '../../components/JoyrideTour';
import { newSolicitationSteps } from '../../constants/Tour/Steps/newSolicitationSteps';
import { ModalAlertConfirmation } from '../../components/Modals/ModalAlertConfirmation';
import { EditHistory } from '../../components/EditHistory';
import { ISolicitationViewModel } from 'viewModels';

export function Solicitation() {
  const theme = useTheme();
  const { user } = useAuth();
  const { enumCorrespondenceType, fieldsRequireds, uiVisibilitySettings } = useConfig();
  const alert = useAlert();
  const app = useApp();
  const { courts, setDistrictSelectedId, districtSelectedId, isLoadingCourts } = useCourts();
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const isEditMode = !!id;
  const { jobValuesByUser, setJobValuesByUser } = useJobValues();
  const { specialties, specialtiesSelectedByUser } = useSpecialties();
  const {
    correspondences,
    setCorrespondences,
    setCorrespondencesSelectedByUser,
    correspondencesSelectedByUser,
  } = useCorrespondences();
  const { clients, setEnableClientsLoad } = useClients();
  const { refetchSolicitation, setSolicitations } = useSolicitation();
  const [isOpenConfirmTermModal, setIsOpenConfirmTermModal] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const Hour = Array.from(Array(24).keys());
  const Minutes = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
    26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
    50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
  ];
  const { handleFetchDistrictsByUfCode } = useDistricts();
  const [minutesLimit, setMinutesLimit] = useState(0);
  const [isInvalidDate, setIsInvalidDate] = useState(false);
  const [lastAddress, setLastAddress] = useState('');
  const [isAddressInvalid, setIsAddressInvalid] = useState(false);
  const [addressValues, setAddressValues] = useState({
    street: '',
    number: '',
    neighborhood: '',
    city: '',
    state: '',
  });
  const [dateLimit, setDateLimit] = useState<Date | null>(new Date());
  const [attachments, setAttachments] = useState<CustomFile[]>([] as CustomFile[]);
  const [existingAttachmentIds, setExistingAttachmentIds] = useState<string[]>([]);
  const [hourLimit, setHourLimit] = useState<number | null>(new Date().getHours());
  const [dateEvents] = useState<Date>(new Date());
  const [solicitation, setSolicitation] = useState<ISolicitationDuplicatedViewModel>();
  const [solicitationData, setSolicitationData] = useState<ISolicitationViewModel>();
  const [matchSolicitation, setMatchSolicitation] = useState<ISolicitationDuplicatedViewModel>();
  const [isOpenModalDuplicateSolicitation, setIsOpenModalDuplicateSolicitation] = useState(false);
  const [isOtherDistrictSelected, setIsOtherDistrictSelected] = useState(false);
  const [runningTutorial, setRunningTutorial] = useState(false);
  const [isOtherCorrespondenceServiceSelected, setIsOtherCorrespondenceServiceSelected] =
    useState(false);
  const [pendingCourtId, setPendingCourtId] = useState<string | null>(null);
  const [pendingCorrespondenceId, setPendingCorrespondenceId] = useState<string | null>(null);
  const [isLoadingEditData, setIsLoadingEditData] = useState(false);
  const [isValueManuallyEdited, setIsValueManuallyEdited] = useState(false);
  const [previousCorrespondenceId, setPreviousCorrespondenceId] = useState<string | undefined>();
  const [previousDistrictUfCode, setPreviousDistrictUfCode] = useState<number | undefined>();
  const { isLoggedWithGoogle, saveEvent: createEventsGoogle } = useGoogleEvents(dateEvents);
  const [defaultValues] = useState<
    ISolicitationInputModel & {
      otherDistrictName: string;
      otherCorrespondenceService: string;
      otherCourtName: string;
      street: string;
      number: string;
      neighborhood: string;
      city: string;
      state: string;
    }
  >({
    clientId: '',
    dateLimit: new Date(),
    isVirtualAudience: undefined as boolean | undefined,
    districtName: '',
    districtUfCode: 0,
    otherDistrictName: '',
    otherCorrespondenceService: '',
    otherCourtName: '',
    specialtyId: undefined,
    value: 0,
    courtId: '',
    correspondenceId: '',
    processNumber: '',
    folderNumber: '',
    note: '',
    audienceType: undefined,
    audienceLink: '',
    partsNames: [
      {
        name: '',
      },
    ],
    street: '',
    number: '',
    neighborhood: '',
    city: '',
    state: '',
  } as ISolicitationInputModel & { otherDistrictName: string; otherCorrespondenceService: string; otherCourtName: string; street: string; number: string; neighborhood: string; city: string; state: string });

  const partInputModelSchema = yup.object().shape({
    name: yup.string(),
    solicitationId: yup.string(),
  });

  const registerSchema: yup.SchemaOf<ISolicitationInputModel> = yup.object({
    correspondenceId: yup.string().required('Selecione o serviço'),
    address: yup.object(),
    isOff: yup.boolean(),
    name: yup.string(),
    type: yup.mixed<CorrespondenceType>().oneOf(Object.values(CorrespondenceType) as number[]),
    attachments: yup.array(),
    dateLimit: yup.date().required('Informe uma data'),
    note: yup.string(),
    processNumber: fieldsRequireds?.solicitation.processNumber
      ? yup.string().required('Número do processo é obrigatório')
      : yup.string(),
    clientId: fieldsRequireds?.solicitation.client
      ? yup.string().required('Cliente é obrigatório')
      : yup.string(),
    courtId: fieldsRequireds?.solicitation.court
      ? yup.string().required('Vara ou Juizado é obrigatório')
      : yup.string(),
    partsNames: fieldsRequireds?.solicitation.parts
      ? yup
          .array()
          .of(partInputModelSchema)
          .test('at-least-one-part', 'Informe pelo menos uma parte', (array) => {
            const hasError =
              array?.some((part) => part.name && part.name.trim().length > 0) ?? false;
            return hasError;
          })
      : yup.array(),
    folderNumber: fieldsRequireds?.solicitation.folderNumber
      ? yup.string().required('Número da Pasta Interno é obrigatório')
      : yup.string(),
    audienceType: yup
      .mixed<AudienceType>()
      .oneOf(Object.values(AudienceType) as number[])
      .when('type', {
        is: CorrespondenceType.AUDIENCE,
        then: yup
          .mixed<AudienceType>()
          .oneOf(Object.values(AudienceType) as number[])
          .required('Tipo de audiência é obrigatório'),
      }),
    secrecy: yup.boolean(),
    specialtyId: yup.string(),
    value: yup.number().min(1, 'Valor mínimo é R$ 1,00').required('Valor é obrigatório'),
    userId: yup.string(),
    concluedAt: yup.date(),
    externalServiceType: yup.string(),
    departmentId: yup.string(),
    profileId: yup.string(),
    isLawyer: yup.boolean(),
    isRepresentative: yup.boolean(),
    isVirtualAudience: yup.boolean().when('type', {
      is: CorrespondenceType.AUDIENCE,
      then: (schema) =>
        schema.oneOf([true, false], 'Modalidade da audiência é obrigatória'),
    }),
    audienceLink: yup.string().when('isVirtualAudience', {
      is: true,
      then: yup.string().required('Link da audiência virtual é obrigatório'),
    }),
    quantity: yup.number().when('isIntegratedProtocol', {
      is: true,
      then: yup
        .number()
        .typeError('Informe um número para a quantidade de protocolos integrados')
        .min(1, 'Quantidade mínima de protocolos integrados é 1')
        .max(999, 'Quantidade máxima de protocolos integrados é 999'),
    }),
    otherCorrespondenceService: yup.string().when('correspondenceId', {
      is: 'other-service',
      then: yup.string().required('Nome do novo serviço é obrigatório'),
    }),
    otherCourtName: isOtherDistrictSelected
      ? yup.string().required('Vara ou Juizado é obrigatório')
      : yup.string(),
    districtName: yup.string().required('Comarca é obrigatória'),
    districtUfCode: yup.number().required('Selecione o estado'),
    street: yup.string().when(['type', 'isVirtualAudience'], {
      is: (type: CorrespondenceType, isVirtualAudience: boolean) =>
        type === CorrespondenceType.AUDIENCE && !isVirtualAudience,
      then: yup.string().required('Rua é obrigatória'),
      otherwise: yup.string().nullable(),
    }),
    number: yup.string().when(['type', 'isVirtualAudience'], {
      is: (type: CorrespondenceType, isVirtualAudience: boolean) =>
        type === CorrespondenceType.AUDIENCE && !isVirtualAudience,
      then: yup
        .string()
        .required('Número é obrigatório')
        .test('valid-number', 'Informe o número ou S/N se não houver', isValidAudienceNumberField),
      otherwise: yup.string().nullable(),
    }),
    neighborhood: yup.string().when(['type', 'isVirtualAudience'], {
      is: (type: CorrespondenceType, isVirtualAudience: boolean) =>
        type === CorrespondenceType.AUDIENCE && !isVirtualAudience,
      then: yup.string().required('Bairro é obrigatório'),
      otherwise: yup.string().nullable(),
    }),
    city: yup.string().when(['type', 'isVirtualAudience'], {
      is: (type: CorrespondenceType, isVirtualAudience: boolean) =>
        type === CorrespondenceType.AUDIENCE && !isVirtualAudience,
      then: yup.string().required('Cidade é obrigatória'),
      otherwise: yup.string().nullable(),
    }),
    state: yup.string().when(['type', 'isVirtualAudience'], {
      is: (type: CorrespondenceType, isVirtualAudience: boolean) =>
        type === CorrespondenceType.AUDIENCE && !isVirtualAudience,
      then: yup.string().required('Estado é obrigatório'),
      otherwise: yup.string().nullable(),
    }),
  });

  const debouncedAddress = useDebounce(addressValues, 2000);

  const handleInputChange = (field: keyof typeof addressValues, value: string) => {
    setIsAddressInvalid(false);
    setAddressValues((prev) => ({ ...prev, [field]: value }));
  };

  const {
    handleSubmit,
    setValue,
    control,
    clearErrors,
    setError,
    resetField,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registerSchema),
    reValidateMode: 'onChange',
    defaultValues,
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'partsNames',
  });

  const [
    processNumber,
    correspondenceId,
    isVirtualAudience,
    districtUfCode,
    districtName,
    otherDistrictName,
    otherCorrespondenceService,
    otherCourtName,
    correspondenceType,
    inputValue,
    state,
  ] = useWatch({
    control,
    name: [
      'processNumber',
      'correspondenceId',
      'isVirtualAudience',
      'districtUfCode',
      'districtName',
      'otherDistrictName',
      'otherCorrespondenceService',
      'otherCourtName',
      'type',
      'value',
      'state',
    ],
  });

  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.colors.background_white,
        color: theme.colors.secondary,
        maxHeight: 250,
      },
    },
  };

  const handleSelectDate = (e: Date | null) => {
    const dateNow = new Date();
    const date = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
    if (e) {
      const dateEvent = new Date(e.getFullYear(), e.getMonth(), e.getDate());
      if (dateEvent >= date) {
        setDateLimit(e);
        setIsInvalidDate(false);
      } else {
        setIsInvalidDate(true);
      }
    }
  };

  const handleGenerateSolicitation = async (data: ISolicitationInputModel) => {
    if (uiVisibilitySettings?.showConfirmSolicitationTermModal) {
      setIsOpenConfirmTermModal(true);
    } else {
      requestGenerateSolicitation(data);
    }
  };

  const requestGenerateSolicitation = async (data: ISolicitationInputModel) => {
    if (isRequesting) return;
    if (isAddressInvalid) {
      const addressFields = ['street', 'number', 'neighborhood', 'city', 'state'];
      addressFields.forEach((field) => {
        setError(field as keyof typeof defaultValues, {
          type: 'manual',
          message: 'Endereço inválido.',
        });
      });
      alert.show({
        type: 'error',
        message: 'Por favor, corrija os erros no endereço antes de continuar.',
      });
      return;
    }
    let date = new Date();
    let newCorrespondenceId = '';
    let newCourtId = '';
    let newDistrictId = '';
    const userId = user.type === TypeUser.COLLABORATOR ? user.collaboratorInfo?.companyId : user.id;
    if (dateLimit && hourLimit !== null) {
      // Create date using local São Paulo time
      date = new Date(
        dateLimit.getFullYear(),
        dateLimit.getMonth(),
        dateLimit.getDate(),
        hourLimit,
        minutesLimit || 0,
      );
    }

    if (isOtherCorrespondenceServiceSelected) {
      const input: IAddCorrespondenceInputModel = {
        name: otherCorrespondenceService,
        isCollaborator: user.type === TypeUser.COLLABORATOR,
      };
      newCorrespondenceId = await CorrespondenceController.addCorrespondence(input)
        .then(async (id) => {
          setCorrespondences((prev) => [
            ...prev,
            {
              id,
              name: otherCorrespondenceService,
              type: CorrespondenceType.CUSTOM,
              userId,
            },
          ]);
          await UserController.updateCorrespondeceForUser(id)
            .then(() => {
              setCorrespondencesSelectedByUser((prev) => [
                ...prev,
                {
                  id,
                  name: otherCorrespondenceService,
                  type: CorrespondenceType.CUSTOM,
                  userId,
                },
              ]);
            })
            .catch(() => {
              alert.show({
                type: 'error',
                message:
                  'Houve um erro ao atualizar sua lista de serviços. Tente novamente mais tarde!',
              });
            });
          const newJobValue: IJobValuesUpdateInputModel = {
            ufCode: districtUfCode,
            values: { [id]: data.value },
          };
          UserController.updateJobValues(newJobValue)
            .then(() => {
              setJobValuesByUser((prev) => ({
                ...prev,
                valuesByUfCode: {
                  ...prev?.valuesByUfCode,
                  [newJobValue.ufCode]: newJobValue.values,
                },
              }));
            })
            .catch(() => {
              alert.show({
                type: 'error',
                message: 'Houve um erro ao atualizar seus valores. Tente novamente mais tarde!',
              });
            });
          return id;
        })
        .catch(() => {
          alert.show({
            type: 'error',
            message: 'Houve um erro ao adicionar seu novo serviço. Tente novamente mais tarde!',
          });
          return '';
        });
    }
    if (isOtherCorrespondenceServiceSelected && !newCorrespondenceId) {
      setError('correspondenceId', { type: 'manual', message: 'Não foi possível criar o serviço' });
      return;
    }
    if (isOtherDistrictSelected) {
      newDistrictId = await DistrictController.addDistrict({
        name: otherDistrictName,
        ufCode: districtUfCode,
        uf: BRAZILIAN_STATES.find((s) => s.ufCode === districtUfCode)?.name || '',
      }).catch(() => {
        alert.show({
          type: 'error',
          message: 'Houve um erro ao adicionar a nova comarca. Tente novamente mais tarde!',
        });
        return '';
      });
      if (newDistrictId) {
        newCourtId = await CompanyController.addCourt({
          name: otherCourtName,
          districtId: newDistrictId,
        }).catch(() => {
          alert.show({
            type: 'error',
            message:
              'Houve um erro ao adicionar a nova vara ou juizado. Tente novamente mais tarde!',
          });
          return '';
        });
      }
    }
    if (isOtherDistrictSelected && !newCourtId) {
      setError('otherCourtName', {
        type: 'manual',
        message: 'Não foi possível criar a vara ou juizado',
      });
      return;
    }
    // CRITICAL: Ensure address.uf is ALWAYS set when address exists (required by backend)
    let addressToSend = data.address;
    if (!isVirtualAudience && addressToSend) {
      // Get state from form field - this is the source of truth
      const currentState = getValues('state');
      let stateUfCode: number | null = null;

      // Try to get ufCode from state field first
      if (currentState) {
        stateUfCode = Number(currentState);
        if (isNaN(stateUfCode)) {
          stateUfCode = null;
        }
      }

      // Fallback to address.ufCode if state field is empty
      if (!stateUfCode && addressToSend.ufCode) {
        stateUfCode = Number(addressToSend.ufCode);
      }

      // If we have ufCode, ensure uf is set
      if (stateUfCode && stateUfCode > 0) {
        const ufAbbrev = UF_BY_CODE[stateUfCode] || '';
        addressToSend = {
          ...addressToSend,
          uf: ufAbbrev || addressToSend.uf || '', // Use ufAbbrev, fallback to existing uf
          ufCode: stateUfCode,
        };
      } else if (!addressToSend.uf) {
        // If no ufCode available but we have uf in address, keep it
        // Otherwise, this is an error case - address should have uf
        console.error('[Address] No ufCode available and no uf in address');
      }
    }

    const input: ISolicitationInputModel = {
      ...data,
      address: isVirtualAudience ? undefined : addressToSend,
      processNumber: data.processNumber ? unMask(data.processNumber) : '',
      audienceType: data.audienceType,
      dateLimit: date,
      partsNames: data.partsNames.filter((part) => part.name.trim()?.length > 0),
      userId,
      // Convert empty strings to undefined for optional Guid fields
      courtId: isOtherDistrictSelected
        ? newCourtId || undefined
        : data.courtId && data.courtId.trim() !== ''
        ? data.courtId
        : undefined,
      correspondenceId: isOtherCorrespondenceServiceSelected
        ? newCorrespondenceId || data.correspondenceId
        : data.correspondenceId,
      districtName: isOtherDistrictSelected ? otherDistrictName : districtName,
      profileId:
        user.type === TypeUser.COLLABORATOR ? user?.collaboratorInfo?.profileId : undefined,
      departmentId:
        user.type === TypeUser.COLLABORATOR ? user?.collaboratorInfo?.departmentId : undefined,
      specialtyId:
        data.specialtyId === 'other'
          ? undefined
          : data.specialtyId && data.specialtyId.trim() !== ''
          ? data.specialtyId
          : undefined,
      clientId: data.clientId && data.clientId.trim() !== '' ? data.clientId : undefined,
    };
    const formData = serialize(input, { indices: true });
    // Only send new attachments (those without an existing ID)
    const newAttachments = attachments.filter(
      (att) => !att.id || !existingAttachmentIds.includes(att.id),
    );
    newAttachments.forEach((file) => formData.append('attachments', file.file));

    // Send list of existing attachment IDs to keep (for removal tracking)
    // This allows the backend to know which attachments to keep and which to remove
    // Only send this in edit mode to avoid affecting new solicitations
    if (isEditMode) {
      const keepAttachmentIds = attachments
        .filter((att) => att.id && existingAttachmentIds.includes(att.id))
        .map((att) => att.id!);

      // Append each ID with index for proper array binding in ASP.NET Core
      // If list is empty, backend will remove all existing attachments
      // If list has items, backend will keep only those and remove the rest
      keepAttachmentIds.forEach((id, index) => {
        formData.append(`keepAttachmentIds[${index}]`, id);
      });

      // Note: If keepAttachmentIds is empty, the backend will receive an empty list
      // and will remove all existing attachments. This is the desired behavior.
    }

    const form: { [key: string]: FormDataEntryValue } = {};
    formData.forEach((value, key) => {
      form[key] = value;
    });
    app.setLoading(true);
    setIsRequesting(true);
    const duplicated = await SolicitationController.compareBeforeInsert(formData)
      .catch(() => {
        alert.show({
          type: 'error',
          message: 'Houve um erro ao comparar a solicitação. Tente novamente mais tarde!',
        });
      })
      .finally(() => {
        app.setLoading(false);
        setIsRequesting(false);
      });
    app.setLoading(true);
    if (isEditMode && id) {
      // Update existing solicitation
      SolicitationController.update(id, formData)
        .then(async () => {
          // Fetch updated solicitation to get the latest data
          const updatedSolicitation = await SolicitationController.getById(id);

          // Update the solicitation in the local state
          setSolicitations((prev) => {
            const newSolicitations = [...prev];
            const idx = newSolicitations.findIndex((item) => item.id === id);
            if (idx !== -1) {
              newSolicitations[idx] = updatedSolicitation;
            }
            return newSolicitations;
          });

          // Refetch the list to ensure it's up to date
          refetchSolicitation();

          alert.show({
            type: 'success',
            message: 'Solicitação atualizada com sucesso',
          });
          navigate('/yoursolicitations');
        })
        .catch(() => {
          alert.show({
            type: 'error',
            message: 'Houve um erro ao atualizar a solicitação. Tente novamente mais tarde!',
          });
        })
        .finally(() => {
          app.setLoading(false);
        });
    } else if (!duplicated) {
      // Insert new solicitation
      SolicitationController.insert(formData)
        .then((newId) => {
          alert.show({
            type: 'success',
            message: 'Solicitação gerada com sucesso',
          });
          user.type === TypeUser.COLLABORATOR
            ? navigate('/yoursolicitations')
            : navigate('/approvalsolicitation', {
                state: newId,
              });
        })
        .catch(() => {
          alert.show({
            type: 'error',
            message: 'Houve um erro ao cadastrar a solicitação. Tente novamente mais tarde!',
          });
        })
        .finally(() => {
          app.setLoading(false);
        });
    } else {
      setMatchSolicitation(duplicated);
      setSolicitation({
        address: isVirtualAudience
          ? undefined
          : {
              latitude: data?.address?.latitude ?? 0,
              longitude: data?.address?.longitude ?? 0,
              number: data?.address?.number,
              street: data?.address?.street,
            },
        correspondence: correspondences?.find((c) => c.id === input.correspondenceId),
        processNumber: data.processNumber,
        folderNumber: data.folderNumber,
        parts: data.partsNames.map((part) => part.name),
      });
      setIsOpenModalDuplicateSolicitation(true);
    }

    const correspondence = correspondences?.find((c) => c.id === input.correspondenceId);
    if (isLoggedWithGoogle) {
      createEventsGoogle(
        correspondence?.name,
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
        hourLimit,
        minutesLimit,
      );
    }
  };

  const onError = () => {
    document.documentElement.scrollTop = 5;
  };

  const handleDiscartSolicitation = () => {
    window.location.reload();
  };

  const handleGetDataFromProcess = async (input: string) => {
    if (!fieldsRequireds?.solicitation.processNumber) return;
    if (input?.length === 25) {
      resetField('partsNames');
      resetField('districtName');
      resetField('districtUfCode');
      app.setLoading(true);
      SolucionareController.getProcessSolucionare(input)
        .then(async (data) => {
          if (!data)
            alert.show({
              type: 'error',
              message: 'Não foi possível encontrar o processo. Tente novamente mais tarde!',
            });
          if (data?.processCover?.federativeUnit && data?.processCover?.districtName) {
            const ufCode = UF_CODE_BY_NAME[data.processCover.federativeUnit];
            if (ufCode) {
              setValue('districtUfCode', ufCode);
              const districts = await handleFetchDistrictsByUfCode(ufCode);
              const findedDistrict = districts.find(
                (d) =>
                  d.ufCode === ufCode &&
                  slugify(data.processCover.districtName).includes(slugify(d.name)),
              );
              if (findedDistrict) {
                setValue('districtName', findedDistrict.name);
                setDistrictSelectedId(findedDistrict.id);
              } else {
                setValue('districtName', 'Outra Comarca');
                setValue('otherDistrictName', data.processCover.districtName);
              }
            }
          }
          const resParties = data.parties;
          const resLawyers = data.lawyers;
          if (resParties?.length > 0) {
            setValue('partsNames.0.name', ``);

            const firstPart = resParties.shift();
            if (firstPart) {
              setValue('partsNames.0.name', `${firstPart.name} (${firstPart?.type ?? '-'})`);
              if (resParties?.length > 0) {
                resParties.forEach((part) => {
                  append({ name: `${part.name} (${part?.type ?? '-'})` });
                });
              }
            }
          }
          if (resLawyers?.length > 0) {
            resLawyers.forEach((lawyer) => {
              append({ name: `${lawyer.name} (Advogado)` });
            });
          }
        })
        .catch(() => {
          alert.show({
            type: 'error',
            message: 'Houve um erro ao buscar os dados do processo. Tente novamente mais tarde!',
          });
        })
        .finally(() => {
          app.setLoading(false);
        });
    }
  };

  function formatName(name: string) {
    if (!name) return '';
    return name
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  const translateCorrespondenceType = (type: string) => {
    const translations: Record<string, string> = {
      DILIGENCE: 'Diligência',
      AUDIENCE: 'Audiência',
      PROTOCOL: 'Protocolo',
      CUSTOM: 'Customizado',
    };
    return translations[type] || type;
  };

  const correspondenceTypeOptions = useMemo(() => {
    if (!enumCorrespondenceType) return [];
    return Object.entries(enumCorrespondenceType)
      .map(([key, value]) => ({
        id: value,
        value: translateCorrespondenceType(key),
      }))
      .sort((a, b) => a.value.localeCompare(b.value));
  }, [enumCorrespondenceType]);

  const suggestedValue = useMemo(() => {
    if (!correspondenceId || !jobValuesByUser?.valuesByUfCode || !districtUfCode) return 0;

    const values = Object.entries(jobValuesByUser.valuesByUfCode).find(
      ([ufCodeKey]) => Number(ufCodeKey ?? '') === districtUfCode,
    )?.[1];
    if (!values) return 0;
    const valueByCorrespondenceId = Object.entries(values).find(
      ([keyCorrespondenceId]) => keyCorrespondenceId === correspondenceId,
    )?.[1];
    if (!valueByCorrespondenceId) return 0;
    return valueByCorrespondenceId;
  }, [correspondenceId, jobValuesByUser, districtUfCode]);

  useEffect(() => {
    if (isVirtualAudience) {
      clearErrors('address');
    }
  }, [clearErrors, isVirtualAudience]);

  // Detect when correspondenceId or districtUfCode changes during edit mode
  // and reset isValueManuallyEdited to allow automatic value update
  useEffect(() => {
    // Only track changes after initial data load is complete
    if (isEditMode && !isLoadingEditData) {
      const correspondenceChanged =
        previousCorrespondenceId !== undefined &&
        previousCorrespondenceId !== '' &&
        previousCorrespondenceId !== correspondenceId &&
        correspondenceId !== '';
      const districtChanged =
        previousDistrictUfCode !== undefined &&
        previousDistrictUfCode !== 0 &&
        previousDistrictUfCode !== districtUfCode &&
        districtUfCode !== 0;

      if (correspondenceChanged || districtChanged) {
        // Allow value to be updated when demand type or district changes
        setIsValueManuallyEdited(false);
      }
    }

    // Update previous values only if they have valid values
    if (correspondenceId && correspondenceId !== '') {
      setPreviousCorrespondenceId(correspondenceId);
    }
    if (districtUfCode && districtUfCode !== 0) {
      setPreviousDistrictUfCode(districtUfCode);
    }
  }, [
    correspondenceId,
    districtUfCode,
    isEditMode,
    isLoadingEditData,
    previousCorrespondenceId,
    previousDistrictUfCode,
  ]);

  useEffect(() => {
    // Don't override value when loading edit data
    if (isLoadingEditData) {
      return;
    }

    // Don't override if user has manually edited the value
    // (unless it was reset due to correspondenceId/districtUfCode change)
    if (isValueManuallyEdited) {
      return;
    }

    // In edit mode, allow update when correspondenceId or districtUfCode changes
    // (isValueManuallyEdited will be false in that case, allowing the update)
    // Only block if value > 0 AND it wasn't changed by user action (isValueManuallyEdited is true)
    // Since we already checked isValueManuallyEdited above, we can proceed with update

    if (
      !correspondenceId ||
      !districtUfCode ||
      isOtherCorrespondenceServiceSelected ||
      isOtherDistrictSelected
    ) {
      clearErrors('value');
      return;
    }

    if (suggestedValue > 0) {
      setValue('value', suggestedValue);
      clearErrors('value');
    } else {
      setValue('value', suggestedValue);
      setError('value', {
        type: 'manual',
        message:
          'Você pode inserir o valor manualmente porque não há valor cadastrado para este serviço.',
      });
    }
  }, [
    clearErrors,
    correspondenceId,
    districtUfCode,
    isOtherCorrespondenceServiceSelected,
    isOtherDistrictSelected,
    setError,
    setValue,
    suggestedValue,
    isLoadingEditData,
    isEditMode,
    inputValue,
    isValueManuallyEdited,
  ]);

  useEffect(() => {
    if (inputValue > 0) {
      clearErrors('value');
    }
  }, [clearErrors, inputValue]);

  useEffect(() => {
    const hasServiceWithSameName = correspondences.some(
      (c) => c.name.toLowerCase() === otherCorrespondenceService.toLowerCase(),
    );
    if (hasServiceWithSameName) {
      setError('otherCorrespondenceService', {
        type: 'manual',
        message: 'Já existe um serviço com esse nome',
      });
    } else {
      clearErrors('otherCorrespondenceService');
    }
  }, [clearErrors, correspondences, otherCorrespondenceService, setError]);

  useEffect(() => {
    setIsOtherDistrictSelected(districtName === 'Outra Comarca');
  }, [districtName]);

  useEffect(() => {
    setIsOtherCorrespondenceServiceSelected(correspondenceId === 'other-service');
  }, [correspondenceId]);

  useEffect(() => {
    const { street, number, neighborhood, city, state } = debouncedAddress;
    const stateUfCode = getValues('state');
    const normalizedCity = normalizeCityName(city);

    if (street && number && neighborhood && city && state) {
      const addressParts = {
        street,
        number,
        neighborhood,
        city: normalizedCity,
        state,
        stateUfCode,
      };
      const cacheKey = buildAddressCacheKey(addressParts);

      if (cacheKey !== lastAddress) {
        setLastAddress(cacheKey);

        const geocodeQueries = buildGeocodingAddressQueries(addressParts);

        const resolveLocation = async () => {
          for (const query of geocodeQueries) {
            try {
              const response = await UserController.getLocationByAddress(query);
              const location = response?.candidates?.[0]?.geometry?.location;
              if (response && response.status !== 'ZERO_RESULTS' && location) {
                return { response, location };
              }
            } catch {
              // tenta próxima variação do endereço
            }
          }
          return null;
        };

        resolveLocation()
          .then(async (result) => {
            if (!result) {
              setIsAddressInvalid(true);
              const addressFields = ['street', 'number', 'neighborhood', 'city', 'state'];
              addressFields.forEach((field) => {
                setError(field as keyof typeof defaultValues, {
                  type: 'manual',
                  message: 'Endereço inválido.',
                });
              });
              alert.show({
                type: 'error',
                message: 'Endereço não encontrado. Verifique os dados ou use S/N se não houver número.',
              });
              return;
            }

            const { response, location } = result;
            const uf = UF_KEYS[changeSpaceToUnderline(state)];
            const cityCode =
              normalizedCity && state
                ? (await getCodeByName(slugify(normalizedCity), slugify(state)))?.id ?? 0
                : 0;

            const currentAddress = getValues('address') || {};
            let ufToUse = uf;
            let ufCodeToUse = currentAddress.ufCode;

            if (!ufToUse || ufToUse.trim() === '') {
              const currentState = getValues('state');
              if (currentState) {
                const stateCode = Number(currentState);
                if (stateCode && !isNaN(stateCode)) {
                  ufToUse = UF_BY_CODE[stateCode] || '';
                  ufCodeToUse = stateCode;
                }
              }
            }

            if (!ufToUse && currentAddress.uf) {
              ufToUse = currentAddress.uf;
            }
            if (!ufCodeToUse && currentAddress.ufCode) {
              ufCodeToUse = currentAddress.ufCode;
            }

            let finalUfCode: number = ufCodeToUse || 0;
            if (!ufCodeToUse && ufToUse) {
              const foundEntry = Object.entries(UF_BY_CODE).find(
                ([_, abbrev]) => abbrev === ufToUse,
              );
              if (foundEntry) {
                finalUfCode = Number(foundEntry[0]);
              }
            }

            setValue('address', {
              latitude: location.lat,
              longitude: location.lng,
              street: formatName(street),
              number: parseAddressNumber(number),
              city: formatName(normalizedCity),
              cityCode,
              uf: ufToUse || uf,
              ufCode: finalUfCode,
              postalCode: extractPostalCode(response?.candidates[0]?.formatted_address) ?? '',
              complement: currentAddress.complement || '',
            });
            setIsAddressInvalid(false);

            clearErrors('street');
            clearErrors('number');
            clearErrors('neighborhood');
            clearErrors('city');
            clearErrors('state');
          })
          .catch(() => {
            alert.show({
              type: 'error',
              message: 'Erro ao buscar endereço.',
            });
            setIsAddressInvalid(true);
          });
      }
    }
  }, [debouncedAddress]);

  useEffect(() => {
    setEnableClientsLoad(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load solicitation data for edit mode
  useEffect(() => {
    if (isEditMode && id) {
      setIsLoadingEditData(true);
      app.setLoading(true);
      SolicitationController.getById(id)
        .then(async (solicitationData) => {
          setSolicitationData(solicitationData);
          // Check if user is the author
          if (solicitationData.createdBy?.id !== user.id) {
            alert.show({
              type: 'error',
              message: 'Você não tem permissão para editar esta solicitação.',
            });
            navigate('/yoursolicitations');
            return;
          }
          // Status check removed - all solicitations can now be edited
          // Populate form with existing data
          // IMPORTANT: Set type FIRST, as it filters the correspondence dropdown
          if (solicitationData.correspondence?.type !== undefined) {
            // Ensure type is set as number to match enumCorrespondenceType values
            setValue('type', Number(solicitationData.correspondence.type));
          }

          // Set district and state first (needed for courts)
          if (solicitationData.districtUfCode) {
            setValue('districtUfCode', solicitationData.districtUfCode);
            // Initialize previous district value
            setPreviousDistrictUfCode(solicitationData.districtUfCode);
          }

          // Set value BEFORE loading district to prevent it from being overridden
          if (solicitationData.value !== undefined && solicitationData.value !== null) {
            setValue('value', solicitationData.value);
            // Mark as manually edited to prevent suggestedValue from overriding it
            setIsValueManuallyEdited(true);
          }

          // Store courtId early to ensure it's available when courts load
          // Try courtId first, then court.id as fallback
          const courtIdToSet = solicitationData.courtId || solicitationData.court?.id;
          if (courtIdToSet) {
            setPendingCourtId(courtIdToSet);
          } else {
            console.log(
              '[EditMode] No courtId found in solicitationData (neither courtId nor court.id)',
            );
          }

          if (solicitationData.districtName) {
            setValue('districtName', solicitationData.districtName);
            // Load courts for the selected district
            if (
              solicitationData.districtUfCode &&
              solicitationData.districtName !== 'Outra Comarca'
            ) {
              try {
                const districts = await handleFetchDistrictsByUfCode(
                  solicitationData.districtUfCode,
                );
                const foundDistrict = districts.find(
                  (d) => d.name === solicitationData.districtName,
                );
                if (foundDistrict) {
                  // Set districtSelectedId to trigger courts loading
                  // pendingCourtId is already set above
                  setDistrictSelectedId(foundDistrict.id);
                } else {
                  console.log('[EditMode] District not found:', solicitationData.districtName);
                }
              } catch (error) {
                console.error('Error loading districts:', error);
              }
            } else {
              // For "Outra Comarca", set the otherCourtName if court exists
              if (solicitationData.court?.name) {
                setValue('otherCourtName', solicitationData.court.name);
              }
            }
          }

          // Store correspondenceId to set after type is processed
          if (solicitationData.correspondence?.id) {
            setPendingCorrespondenceId(solicitationData.correspondence.id);
          }

          // Set other fields
          if (solicitationData.client?.id) setValue('clientId', solicitationData.client.id);

          if (solicitationData.specialty?.id) {
            setValue('specialtyId', solicitationData.specialty.id);
          }
          if (solicitationData.processNumber)
            setValue('processNumber', solicitationData.processNumber);
          if (solicitationData.folderNumber)
            setValue('folderNumber', solicitationData.folderNumber);
          if (solicitationData.note) setValue('note', solicitationData.note);
          // Set audienceType - check for null/undefined explicitly since 0 is a valid value
          if (solicitationData.audienceType !== undefined && solicitationData.audienceType !== null)
            setValue('audienceType', solicitationData.audienceType);
          // Set checkboxes - ensure boolean values are set even if false
          setValue('isLawyer', solicitationData.isLawyer ?? false);
          setValue('isRepresentative', solicitationData.isRepresentative ?? false);
          if (solicitationData.isVirtualAudience !== undefined)
            setValue('isVirtualAudience', solicitationData.isVirtualAudience);
          if (solicitationData.audienceLink)
            setValue('audienceLink', solicitationData.audienceLink);
          // Set date and time in local São Paulo time
          if (solicitationData.dateLimit) {
            const date = new Date(solicitationData.dateLimit);
            setDateLimit(date);
            setHourLimit(date.getHours());
            setMinutesLimit(date.getMinutes());
          }
          // Set address values
          if (solicitationData.address && !solicitationData.isVirtualAudience) {
            const address = solicitationData.address;
            const addressValuesToSet = {
              street: address.street || '',
              number:
                address.number === 0 ? 'S/N' : address.number?.toString() || '',
              neighborhood: address.complement || '', // Using complement as neighborhood is not in the interface
              city: address.city || '',
              state: address.uf || '',
            };

            // Set addressValues state for the input fields
            setAddressValues(addressValuesToSet);

            // Set individual form fields - always set even if empty
            setValue('street', addressValuesToSet.street || '');
            setValue('number', addressValuesToSet.number || '');
            setValue('neighborhood', addressValuesToSet.neighborhood || '');
            setValue('city', addressValuesToSet.city || '');

            // Set state - prefer ufCode if available and valid (not 0), otherwise convert from name or abbreviation
            // Create reverse mapping from UF_BY_CODE (ufCode -> abbreviation) to get abbreviation -> ufCode
            const STATE_ABBREV_TO_CODE: { [key: string]: number } = Object.entries(
              UF_BY_CODE,
            ).reduce((acc, [ufCode, abbrev]) => {
              acc[abbrev] = Number(ufCode);
              return acc;
            }, {} as { [key: string]: number });

            // Set state - use setTimeout to ensure DropDownList has loaded its items
            setTimeout(() => {
              let stateUfCode: number | null = null;

              if (address.ufCode !== undefined && address.ufCode !== null && address.ufCode !== 0) {
                // Use ufCode directly if available and valid
                stateUfCode = address.ufCode;
                setValue('state', address.ufCode.toString());
              } else if (addressValuesToSet.state) {
                // Check if it's a state abbreviation (2 letters)
                const stateAbbrev = addressValuesToSet.state.toUpperCase().trim();
                if (stateAbbrev.length === 2 && STATE_ABBREV_TO_CODE[stateAbbrev]) {
                  stateUfCode = STATE_ABBREV_TO_CODE[stateAbbrev];
                  setValue('state', stateUfCode.toString());
                } else {
                  // Convert state name to ufCode for the dropdown
                  // First, try to find by exact name match
                  let stateFound = BRAZILIAN_STATES.find(
                    (s) => s.name.toLowerCase() === addressValuesToSet.state.toLowerCase(),
                  );

                  // If not found, try using UF_CODE_BY_NAME (handles names with spaces converted to underscores)
                  if (!stateFound) {
                    const ufCode =
                      UF_CODE_BY_NAME[changeSpaceToUnderline(addressValuesToSet.state)];
                    if (ufCode !== undefined) {
                      stateFound = BRAZILIAN_STATES.find((s) => s.ufCode === ufCode);
                    }
                  }

                  // If still not found, try partial match
                  if (!stateFound) {
                    stateFound = BRAZILIAN_STATES.find(
                      (s) =>
                        addressValuesToSet.state.toLowerCase().includes(s.name.toLowerCase()) ||
                        s.name.toLowerCase().includes(addressValuesToSet.state.toLowerCase()),
                    );
                  }

                  // If found, set the ufCode as string (form field expects string)
                  if (stateFound) {
                    stateUfCode = stateFound.ufCode;
                    setValue('state', stateFound.ufCode.toString());
                  } else {
                    // Log for debugging
                    console.warn('[EditMode] State not found:', addressValuesToSet.state);
                  }
                }
              }

              // CRITICAL: Update address.uf when state is set to ensure it's always in sync
              if (stateUfCode !== null && stateUfCode !== undefined) {
                const currentAddress = getValues('address');
                if (currentAddress) {
                  const ufAbbrev = UF_BY_CODE[stateUfCode] || '';
                  setValue('address', {
                    ...currentAddress,
                    uf: ufAbbrev,
                    ufCode: stateUfCode,
                  });
                }
              }
            }, 500);

            // If we have coordinates, use reverse geocoding to get complete address details
            if (address.latitude && address.longitude) {
              GetAddressByGeocoding({
                lat: address.latitude,
                lng: address.longitude,
              })
                .then(async (response) => {
                  if (response?.results && response.results.length > 0) {
                    const result = response.results[0];
                    const addressComponents = result.address_components || [];

                    // Extract address components
                    const streetComponent = addressComponents.find((ac: any) =>
                      ac.types.includes('route'),
                    );
                    const numberComponent = addressComponents.find((ac: any) =>
                      ac.types.includes('street_number'),
                    );
                    const neighborhoodComponent = addressComponents.find(
                      (ac: any) =>
                        ac.types.includes('sublocality') ||
                        ac.types.includes('sublocality_level_1'),
                    );
                    const cityComponent = addressComponents.find((ac: any) =>
                      ac.types.includes('administrative_area_level_2'),
                    );
                    const stateComponent = addressComponents.find((ac: any) =>
                      ac.types.includes('administrative_area_level_1'),
                    );
                    const postalCodeComponent = addressComponents.find((ac: any) =>
                      ac.types.includes('postal_code'),
                    );

                    // Use data from geocoding if available, otherwise fallback to existing data
                    const geocodedStreet = streetComponent?.long_name || address.street || '';
                    const geocodedNumber = numberComponent?.long_name
                      ? parseAddressNumber(numberComponent.long_name)
                      : address.number ?? 0;
                    const geocodedNeighborhood =
                      neighborhoodComponent?.long_name || address.complement || '';
                    const geocodedCity = cityComponent?.long_name || address.city || '';
                    const geocodedState = stateComponent?.short_name || address.uf || '';
                    const geocodedPostalCode =
                      postalCodeComponent?.long_name?.replace(/\D+/g, '') ||
                      address.postalCode ||
                      '';

                    // Update addressValues with geocoded data
                    const updatedAddressValues = {
                      street: geocodedStreet,
                      number: geocodedNumber === 0 ? 'S/N' : geocodedNumber.toString(),
                      neighborhood: geocodedNeighborhood,
                      city: geocodedCity,
                      state: geocodedState,
                    };
                    setAddressValues(updatedAddressValues);

                    // Set form fields with geocoded data
                    setValue('street', geocodedStreet);
                    setValue('number', geocodedNumber === 0 ? 'S/N' : geocodedNumber.toString());
                    setValue('neighborhood', geocodedNeighborhood);
                    setValue('city', geocodedCity);

                    // Set state - convert abbreviation to ufCode
                    // Use setTimeout to ensure DropDownList has loaded its items
                    setTimeout(() => {
                      const STATE_ABBREV_TO_CODE: { [key: string]: number } = Object.entries(
                        UF_BY_CODE,
                      ).reduce((acc, [ufCode, abbrev]) => {
                        acc[abbrev] = Number(ufCode);
                        return acc;
                      }, {} as { [key: string]: number });

                      const stateAbbrev = geocodedState.toUpperCase().trim();
                      if (stateAbbrev.length === 2 && STATE_ABBREV_TO_CODE[stateAbbrev]) {
                        // Set as string (form expects string) but DropDownList will compare correctly
                        setValue('state', STATE_ABBREV_TO_CODE[stateAbbrev].toString());
                      }
                    }, 500);

                    // Get city code
                    const cityCode =
                      geocodedCity && geocodedState
                        ? (await getCodeByName(slugify(geocodedCity), slugify(geocodedState)))
                            ?.id ??
                          address.cityCode ??
                          0
                        : address.cityCode || 0;

                    // Get ufCode from geocoded state abbreviation
                    const STATE_ABBREV_TO_CODE_FOR_GEO: { [key: string]: number } = Object.entries(
                      UF_BY_CODE,
                    ).reduce((acc, [ufCode, abbrev]) => {
                      acc[abbrev] = Number(ufCode);
                      return acc;
                    }, {} as { [key: string]: number });
                    const geocodedUfCode =
                      STATE_ABBREV_TO_CODE_FOR_GEO[geocodedState.toUpperCase()] ||
                      address.ufCode ||
                      0;

                    // Set the complete address object in the form
                    setValue('address', {
                      latitude: address.latitude,
                      longitude: address.longitude,
                      street: geocodedStreet,
                      number: geocodedNumber,
                      city: geocodedCity,
                      cityCode,
                      uf: geocodedState,
                      ufCode: geocodedUfCode,
                      postalCode: geocodedPostalCode,
                      complement: geocodedNeighborhood,
                    });

                    // Set lastAddress to prevent the useEffect from triggering location search
                    const fullAddress = `${geocodedStreet}, ${geocodedNumber}, ${geocodedNeighborhood}, ${geocodedCity}, ${geocodedState}`;
                    setLastAddress(fullAddress);
                  } else {
                    // If geocoding fails, use existing data
                    // Ensure uf is set - use from address.uf or derive from ufCode/state
                    let ufToSet = address.uf || '';
                    if (!ufToSet && address.ufCode) {
                      ufToSet = UF_BY_CODE[address.ufCode] || '';
                    }
                    if (!ufToSet && addressValuesToSet.state) {
                      const stateUfCode =
                        Number(addressValuesToSet.state) ||
                        (addressValuesToSet.state.length === 2
                          ? Object.entries(UF_BY_CODE).find(
                              ([_, abbrev]) => abbrev === addressValuesToSet.state.toUpperCase(),
                            )?.[0]
                          : null);
                      if (stateUfCode) {
                        ufToSet = UF_BY_CODE[Number(stateUfCode)] || addressValuesToSet.state;
                      } else {
                        ufToSet = addressValuesToSet.state;
                      }
                    }

                    setValue('address', {
                      latitude: address.latitude,
                      longitude: address.longitude,
                      street: address.street || '',
                      number: address.number || 0,
                      city: address.city || '',
                      cityCode: address.cityCode || 0,
                      uf: ufToSet,
                      ufCode:
                        address.ufCode ||
                        (addressValuesToSet.state ? Number(addressValuesToSet.state) : 0),
                      postalCode: address.postalCode || '',
                      complement: address.complement || '',
                    });
                    const fullAddress = `${addressValuesToSet.street}, ${addressValuesToSet.number}, ${addressValuesToSet.neighborhood}, ${addressValuesToSet.city}, ${addressValuesToSet.state}`;
                    setLastAddress(fullAddress);
                  }
                })
                .catch(() => {
                  // If geocoding fails, use existing data
                  // Ensure uf is set - use from address.uf or derive from ufCode/state
                  let ufToSet = address.uf || '';
                  if (!ufToSet && address.ufCode) {
                    ufToSet = UF_BY_CODE[address.ufCode] || '';
                  }
                  if (!ufToSet && addressValuesToSet.state) {
                    const stateUfCode =
                      Number(addressValuesToSet.state) ||
                      (addressValuesToSet.state.length === 2
                        ? Object.entries(UF_BY_CODE).find(
                            ([_, abbrev]) => abbrev === addressValuesToSet.state.toUpperCase(),
                          )?.[0]
                        : null);
                    if (stateUfCode) {
                      ufToSet = UF_BY_CODE[Number(stateUfCode)] || addressValuesToSet.state;
                    } else {
                      ufToSet = addressValuesToSet.state;
                    }
                  }

                  setValue('address', {
                    latitude: address.latitude,
                    longitude: address.longitude,
                    street: address.street || '',
                    number: address.number || 0,
                    city: address.city || '',
                    cityCode: address.cityCode || 0,
                    uf: ufToSet,
                    ufCode:
                      address.ufCode ||
                      (addressValuesToSet.state ? Number(addressValuesToSet.state) : 0),
                    postalCode: address.postalCode || '',
                    complement: address.complement || '',
                  });
                  const fullAddress = `${addressValuesToSet.street}, ${addressValuesToSet.number}, ${addressValuesToSet.neighborhood}, ${addressValuesToSet.city}, ${addressValuesToSet.state}`;
                  setLastAddress(fullAddress);
                });
            } else {
              // If no coordinates, set address with available data
              // The coordinates will be fetched when the user interacts with the address
              // Ensure uf is set - use from address.uf or derive from ufCode/state
              let ufToSet = address.uf || '';
              if (!ufToSet && address.ufCode) {
                ufToSet = UF_BY_CODE[address.ufCode] || '';
              }
              if (!ufToSet && addressValuesToSet.state) {
                const stateUfCode =
                  Number(addressValuesToSet.state) ||
                  (addressValuesToSet.state.length === 2
                    ? Object.entries(UF_BY_CODE).find(
                        ([_, abbrev]) => abbrev === addressValuesToSet.state.toUpperCase(),
                      )?.[0]
                    : null);
                if (stateUfCode) {
                  ufToSet = UF_BY_CODE[Number(stateUfCode)] || addressValuesToSet.state;
                } else {
                  ufToSet = addressValuesToSet.state;
                }
              }

              setValue('address', {
                latitude: 0,
                longitude: 0,
                street: address.street || '',
                number: address.number || 0,
                city: address.city || '',
                cityCode: address.cityCode || 0,
                uf: ufToSet,
                ufCode:
                  address.ufCode ||
                  (addressValuesToSet.state ? Number(addressValuesToSet.state) : 0),
                postalCode: address.postalCode || '',
                complement: address.complement || '',
              });
              const fullAddress = `${addressValuesToSet.street}, ${addressValuesToSet.number}, ${addressValuesToSet.neighborhood}, ${addressValuesToSet.city}, ${addressValuesToSet.state}`;
              setLastAddress(fullAddress);
            }
          }
          // Set parts
          if (solicitationData.partsNames && solicitationData.partsNames.length > 0) {
            resetField('partsNames');
            solicitationData.partsNames.forEach((part, index) => {
              if (index === 0) {
                setValue('partsNames.0.name', part.name);
              } else {
                append({ name: part.name });
              }
            });
          }
          // Load existing attachments
          if (solicitationData.attachments && solicitationData.attachments.length > 0) {
            // Convert IFileViewModel[] to CustomFile[]
            const loadAttachments = async () => {
              const loadedAttachments: CustomFile[] = [];
              const existingIds: string[] = [];
              for (const attachment of solicitationData.attachments || []) {
                if (attachment.id) {
                  existingIds.push(attachment.id);
                  try {
                    const blob = await Download(attachment.id);
                    const file = new File([blob], attachment.name || 'arquivo', {
                      type: attachment.contentType || 'application/octet-stream',
                    });
                    const customFile: CustomFile = {
                      id: attachment.id,
                      file,
                      preview: URL.createObjectURL(blob),
                    };
                    loadedAttachments.push(customFile);
                  } catch (error) {
                    console.error('Error loading attachment:', error);
                    // Continue loading other attachments even if one fails
                  }
                }
              }
              setAttachments(loadedAttachments);
              setExistingAttachmentIds(existingIds);
            };
            loadAttachments();
          } else {
            setExistingAttachmentIds([]);
          }
        })
        .catch(() => {
          alert.show({
            type: 'error',
            message: 'Erro ao carregar dados da solicitação.',
          });
          navigate('/yoursolicitations');
        })
        .finally(() => {
          app.setLoading(false);
          // Allow value updates after a short delay to ensure all data is loaded
          setTimeout(() => {
            setIsLoadingEditData(false);
          }, 1000);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, id]);

  // Cleanup attachment preview URLs on unmount
  useEffect(() => {
    return () => {
      attachments.forEach((att) => {
        if (att.preview && att.preview.startsWith('blob:')) {
          URL.revokeObjectURL(att.preview);
        }
      });
    };
  }, [attachments]);

  // CRITICAL: Keep address.uf in sync with state field
  // This ensures that when state is set (even via setTimeout), address.uf is always updated
  useEffect(() => {
    if (isEditMode && !isVirtualAudience && state) {
      const stateUfCode = Number(state);
      if (stateUfCode && !isNaN(stateUfCode)) {
        const currentAddress = getValues('address');
        if (currentAddress) {
          const ufAbbrev = UF_BY_CODE[stateUfCode] || '';
          // Only update if uf is missing or different to avoid unnecessary updates
          if (
            !currentAddress.uf ||
            currentAddress.uf !== ufAbbrev ||
            currentAddress.ufCode !== stateUfCode
          ) {
            setValue('address', {
              ...currentAddress,
              uf: ufAbbrev,
              ufCode: stateUfCode,
            });
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, isEditMode, isVirtualAudience, getValues, setValue]);

  // Set correspondenceId after type is set and correspondences are filtered
  useEffect(() => {
    if (isEditMode && correspondenceType !== undefined && pendingCorrespondenceId) {
      // Wait a bit for correspondences to be filtered by type
      const timer = setTimeout(() => {
        setValue('correspondenceId', pendingCorrespondenceId);
        // Initialize previous correspondence value
        setPreviousCorrespondenceId(pendingCorrespondenceId);
        setPendingCorrespondenceId(null);
      }, 300);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correspondenceType, pendingCorrespondenceId, isEditMode]);

  // Set courtId after courts are loaded
  useEffect(() => {
    // Wait for courts to finish loading before trying to set courtId
    // Note: districtName check is removed to allow setting even if districtName is being set asynchronously
    if (isEditMode && !isLoadingCourts && courts.length > 0 && pendingCourtId) {
      // Verify the court exists in the loaded courts (compare as strings to handle type mismatches)
      const pendingCourtIdString = String(pendingCourtId);
      const courtExists = courts.some((c) => String(c.id) === pendingCourtIdString);

      if (courtExists) {
        // Use setTimeout to ensure the value is set after React has processed the state updates
        // and the DropDownList component has had time to update its items
        const timer = setTimeout(() => {
          setValue('courtId', pendingCourtIdString, {
            shouldValidate: false,
            shouldDirty: false,
          });

          setPendingCourtId(null); // Clear after setting
        }, 600);
        return () => clearTimeout(timer);
      } else {
        // Court not found in the list - this might happen if the court was deleted
        // or if there's a mismatch. Try to set it anyway after a longer delay
        const retryTimer = setTimeout(() => {
          // Check again if courts were updated
          const courtExistsRetry = courts.some((c) => String(c.id) === pendingCourtIdString);
          if (courtExistsRetry) {
            setValue('courtId', pendingCourtIdString, {
              shouldValidate: false,
              shouldDirty: false,
            });
            setPendingCourtId(null);
          } else {
            // If still not found, clear the pending courtId to avoid infinite retries
            console.warn(
              `[CourtId] Court with id ${pendingCourtIdString} not found in loaded courts. Available courts:`,
              courts.map((c) => ({ id: String(c.id), name: c.name })),
            );
            setPendingCourtId(null);
          }
        }, 2500);
        return () => clearTimeout(retryTimer);
      }
    } else {
      // Log why the effect is not running
      if (isEditMode) {
        console.log('[CourtId Effect] Conditions not met:', {
          isEditMode: true,
          isLoadingCourts,
          courtsLength: courts.length,
          hasPendingCourtId: !!pendingCourtId,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courts, pendingCourtId, isEditMode, isLoadingCourts]);

  useEffect(() => {
    if (!user?.tutorialProgress?.some((p) => p === TutorialType.SOLICITATION)) {
      setRunningTutorial(true);
    }
  }, [user.tutorialProgress]);

  return (
    <>
      <JoyrideTour
        type={TutorialType.SOLICITATION}
        steps={newSolicitationSteps}
        run={runningTutorial}
        onCallbackFinished={() => setRunningTutorial(false)}
      />
      <NavHeader typeHeader="company" />
      <Container>
        <div className="titlePage">
          <TitlePage
            title={isEditMode ? 'Editar Solicitação' : 'Solicitação'}
            id="start-item"
            onRequestOpen={() => {
              setRunningTutorial(true);
            }}
          />
        </div>

        <Body>
          <div className="contentGrid">
            <div className="containerServices">
              <div className="containerContent" id="solicitation-item">
                <div className="containerDistrict">
                  <h2>Estado e Comarca de realização do serviço</h2>
                  <div className="containerDistrictBase">
                    <div className="containerDistrictState">
                      <Controller
                        control={control}
                        name="districtUfCode"
                        render={({ field: { onChange } }) => (
                          <DropDownList
                            placeholderTitle="Estado"
                            itens={
                              BRAZILIAN_STATES.map((s) => ({ id: s.ufCode, value: s.name })) ?? []
                            }
                            width="100%"
                            typeReturn="id"
                            value={districtUfCode || ''}
                            onChange={onChange}
                            errorText={errors.districtUfCode?.message}
                          />
                        )}
                      />
                    </div>
                    <div className="containerDistrictName">
                      <div className="contentDropdown">
                        <DropListDistricts
                          name="districtName"
                          control={control}
                          disabled={!districtUfCode}
                          placeholderTitle="Qual é a Comarca?"
                          ufCode={districtUfCode}
                          errorText={
                            districtName !== 'Outra Comarca'
                              ? errors.districtName?.message
                              : undefined
                          }
                        />
                      </div>
                    </div>
                  </div>
                  {isOtherDistrictSelected && (
                    <Input
                      name="otherDistrictName"
                      control={control}
                      placeholder="Nome da comarca"
                      variant="standard"
                      errorText={errors.districtName?.message}
                    />
                  )}
                </div>
                <div className="containerServiceName">
                  <h2>Vara ou Juizado</h2>
                  {isOtherDistrictSelected ? (
                    <Input
                      name="otherCourtName"
                      control={control}
                      placeholder="Nome da Vara ou Juizado"
                      variant="standard"
                      errorText={errors.otherCourtName?.message}
                    />
                  ) : (
                    <Controller
                      control={control}
                      name="courtId"
                      defaultValue=""
                      render={({ field: { onChange, value } }) => (
                        <DropDownList
                          key={`court-${courts.length}-${districtName}`}
                          placeholderTitle="Para qual vara ou juizado você deseja solicitar?"
                          itens={
                            courts
                              ?.sort((a, b) => a.name.localeCompare(b.name))
                              .map((c) => ({ id: String(c.id), value: c.name })) ?? []
                          }
                          typeReturn="id"
                          isSearchable
                          disabled={districtName === ''}
                          onChange={(val) => onChange(String(val))}
                          value={value ? String(value) : ''}
                          errorText={errors.courtId?.message}
                        />
                      )}
                    />
                  )}
                </div>
                <div id="demand-item" className="containerServiceName">
                  <h2>Tipo de Demanda</h2>
                  <Controller
                    control={control}
                    name="type"
                    render={({ field: { onChange, value } }) => (
                      <DropDownList
                        placeholderTitle="Qual tipo de serviço foi demandado?"
                        itens={correspondenceTypeOptions}
                        typeReturn="id"
                        value={value !== undefined && value !== null ? value : ''}
                        onChange={(e) => {
                          onChange(e);
                          setValue('isVirtualAudience', undefined);
                          setValue('correspondenceId', '');
                        }}
                        errorText={errors.correspondenceId?.message}
                        isSearchable
                        messageEmpty="Nenhum serviço de correspondência cadastrado..."
                      />
                    )}
                  />
                </div>
                {correspondenceType !== undefined && (
                  <div className="containerServiceName containerFormSelects">
                    <Controller
                      control={control}
                      name="correspondenceId"
                      render={({ field: { onChange, value } }) => (
                        <DropDownList
                          placeholderTitle="Qual serviço foi demandado?"
                          itens={(correspondenceType === CorrespondenceType.CUSTOM
                            ? [{ id: 'other-service', value: 'Outro Serviço' }]
                            : []
                          ).concat(
                            fieldsRequireds?.solicitation.client
                              ? correspondencesSelectedByUser
                                  ?.filter((c) => c.type === correspondenceType)
                                  .sort((a, b) => a.name.localeCompare(b.name))
                                  .map((c) => ({ id: c.id, value: c.name }))
                              : correspondences
                                  ?.filter((c) => c.type === correspondenceType)
                                  .sort((a, b) => a.name.localeCompare(b.name))
                                  .map((c) => ({ id: c.id, value: c.name })),
                          )}
                          typeReturn="id"
                          value={value !== undefined && value !== null ? value : ''}
                          onChange={onChange}
                          errorText={errors.correspondenceId?.message}
                          isSearchable
                          messageEmpty="Nenhum serviço de correspondência cadastrado..."
                        />
                      )}
                    />
                    {correspondenceType === CorrespondenceType.AUDIENCE && (
                      <>
                        <Controller
                          control={control}
                          name="audienceType"
                          render={({ field: { onChange, value } }) => (
                            <DropDownList
                              placeholderTitle="Qual o tipo de Audiência?"
                              itens={Object.entries(labelAudienceType).map(([id, label]) => ({
                                id: Number(id),
                                value: label,
                              }))}
                              typeReturn="id"
                              onChange={onChange}
                              value={value !== undefined && value !== null ? value : ''}
                              errorText={errors.audienceType?.message}
                              isSearchable
                            />
                          )}
                        />
                        <Controller
                          control={control}
                          name="isVirtualAudience"
                          render={({ field: { onChange, value } }) => (
                            <DropDownList
                              placeholderTitle="Modalidade da Audiência"
                              width="100%"
                              value={
                                value === true ? 'Virtual' : value === false ? 'Presencial' : ''
                              }
                              itens={[
                                { id: 'Virtual', value: 'Audiência Virtual' },
                                { id: 'Presencial', value: 'Audiência Presencial' },
                              ]}
                              typeReturn="id"
                              onChange={(el) => {
                                onChange(el === 'Virtual');
                                if (el === 'Virtual') {
                                  setValue('street', '');
                                  setValue('number', '');
                                  setValue('neighborhood', '');
                                  setValue('city', '');
                                  setValue('state', '');
                                } else {
                                  setValue('audienceLink', '');
                                }
                              }}
                              errorText={errors.isVirtualAudience?.message}
                            />
                          )}
                        />
                      </>
                    )}
                  </div>
                )}
                {isOtherCorrespondenceServiceSelected && (
                  <Input
                    name="otherCorrespondenceService"
                    control={control}
                    placeholder="Nome do Serviço"
                    variant="standard"
                    errorText={errors.otherCorrespondenceService?.message}
                  />
                )}
                {isVirtualAudience === true && correspondenceType === CorrespondenceType.AUDIENCE && (
                  <div className="containerVirtualAudience">
                    <Input
                      name="audienceLink"
                      control={control}
                      placeholder="Link da Audiência"
                      variant="standard"
                      errorText={errors.audienceLink?.message}
                    />
                  </div>
                )}
                {isVirtualAudience === false && correspondenceType === CorrespondenceType.AUDIENCE && (
                  <div className="containerDataAddress">
                    <div className="title">
                      <h2>Local da Audiência</h2>
                      <Tooltip
                        disableInteractive
                        title="Preencha rua, número (ou S/N se não houver), bairro, cidade e estado."
                        placement="top"
                        arrow>
                        <Info />
                      </Tooltip>
                    </div>
                    <div className="street-number">
                      <div className="street">
                        <Input
                          name="street"
                          control={control}
                          placeholder="Rua"
                          variant="standard"
                          errorText={errors.street?.message}
                          value={addressValues.street}
                          onChange={(e) => handleInputChange('street', e.target.value)}
                        />
                      </div>
                      <div className="number">
                        <Input
                          name="number"
                          control={control}
                          placeholder="Nº ou S/N"
                          variant="standard"
                          errorText={errors.number?.message}
                          value={addressValues.number}
                          onChange={(e) => handleInputChange('number', e.target.value)}
                        />
                      </div>
                    </div>
                    <div>
                      <Input
                        name="neighborhood"
                        control={control}
                        placeholder="Bairro"
                        variant="standard"
                        errorText={errors.neighborhood?.message}
                        value={addressValues.neighborhood}
                        onChange={(e) => handleInputChange('neighborhood', e.target.value)}
                      />
                    </div>
                    <div className="city-state">
                      <div className="city">
                        <Input
                          name="city"
                          control={control}
                          placeholder="Cidade"
                          variant="standard"
                          errorText={errors.city?.message}
                          value={addressValues.city}
                          onChange={(e) => handleInputChange('city', e.target.value)}
                        />
                      </div>
                      <div className="state">
                        <Controller
                          control={control}
                          name="state"
                          render={({ field: { value, onChange } }) => (
                            <DropDownList
                              placeholderTitle="Estado"
                              itens={
                                BRAZILIAN_STATES.map((s) => ({ id: s.ufCode, value: s.name })) ?? []
                              }
                              typeReturn="id"
                              value={value}
                              onChange={(selectedValue) => {
                                handleInputChange('state', UF_NAMES_BY_CODE[Number(selectedValue)]);
                                onChange(selectedValue);
                                clearErrors('state');
                              }}
                              errorText={errors.state?.message}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div id="specialty-item" className="containerArea">
                  <h2>Especialidade</h2>
                  <Controller
                    control={control}
                    name="specialtyId"
                    render={({ field: { onChange, value } }) => (
                      <DropDownList
                        placeholderTitle="Qual a especialidade?"
                        itens={[{ id: 'other', value: 'Outra' }].concat(
                          fieldsRequireds?.solicitation.client
                            ? specialtiesSelectedByUser
                                ?.sort((a, b) => a.name.localeCompare(b.name))
                                .map((s) => ({ id: s.id, value: s.name }))
                            : specialties
                                ?.sort((a, b) => a.name.localeCompare(b.name))
                                .map((s) => ({ id: s.id, value: s.name })),
                        )}
                        typeReturn="id"
                        onChange={onChange}
                        value={value !== undefined && value !== null ? value : ''}
                        errorText={errors.specialtyId?.message}
                        isSearchable
                        messageEmpty="Nenhuma especialidade cadastrada..."
                      />
                    )}
                  />
                </div>
                <div className="containerServiceName">
                  <h2>Cliente</h2>
                  <Controller
                    control={control}
                    name="clientId"
                    render={({ field: { onChange, value } }) => (
                      <DropDownList
                        placeholderTitle="Para qual cliente você deseja solicitar?"
                        itens={clients?.map((c) => ({ id: c.id, value: c.name })) ?? []}
                        typeReturn="id"
                        isSearchable
                        width="100%"
                        onChange={onChange}
                        errorText={errors.clientId?.message}
                        value={value}
                      />
                    )}
                  />
                </div>
                {correspondenceType === CorrespondenceType.AUDIENCE && (
                  <div>
                    <h2>Representação</h2>
                    <div className="containerCheckbox">
                      <Controller
                        control={control}
                        name="isLawyer"
                        render={({ field: { value, onChange, ...rest } }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value || false}
                                onChange={(e) => onChange(e.target.checked)}
                                {...rest}
                              />
                            }
                            label=" Advogado"
                          />
                        )}
                      />
                      <Controller
                        control={control}
                        name="isRepresentative"
                        render={({ field: { value, onChange, ...rest } }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value || false}
                                onChange={(e) => onChange(e.target.checked)}
                                {...rest}
                              />
                            }
                            label=" Preposto"
                          />
                        )}
                      />
                    </div>
                  </div>
                )}
                <div>
                  <h2>Número do processo</h2>
                  <Input
                    name="processNumber"
                    control={control}
                    placeholder="Número do processo"
                    variant="standard"
                    lengthInput={25}
                    mask={MASK_PROCESS_NUMBER}
                    errorText={errors.processNumber?.message}
                    preventNotNumbers
                    endAdornment={
                      fieldsRequireds?.solicitation.processNumber ? (
                        <IconButton
                          disabled={!processNumber || processNumber?.length < 25}
                          onClick={() => handleGetDataFromProcess(processNumber)}>
                          <Tooltip disableInteractive title="Pesquisar dados do processo" arrow>
                            <Search />
                          </Tooltip>
                        </IconButton>
                      ) : undefined
                    }
                  />
                </div>
                <div>
                  <h2>Número da Pasta Interno</h2>
                  <Input
                    name="folderNumber"
                    control={control}
                    placeholder="Número da Pasta Interno"
                    variant="standard"
                    lengthInput={50}
                    preventNotNumbers
                    errorText={errors.folderNumber?.message}
                  />
                </div>
                <div>
                  <h2>Partes</h2>
                  <div className="containerPartsName">
                    {fields.map((part, index) => (
                      <div style={{ display: 'flex', width: '100%' }} key={part.id}>
                        <Input
                          name={`partsNames.${index}.name`}
                          defaultValue={part.name ?? ''}
                          control={control}
                          width="100%"
                          placeholder={`Nome da parte ${index + 1}`}
                          variant="standard"
                          lengthInput={50}
                          errorText={index === 0 ? errors.partsNames?.message : undefined}
                        />
                        {index > 0 ? (
                          <IconButton
                            onClick={() => {
                              remove(index);
                            }}>
                            <Remove />
                          </IconButton>
                        ) : undefined}
                      </div>
                    ))}
                  </div>
                  <IconButton
                    onClick={() => {
                      append({ name: '' });
                    }}>
                    <Add />
                  </IconButton>
                </div>
                <div id="value-item" className="suggestionValue">
                  <h2>Valor a ser pago</h2>
                  <Controller
                    control={control}
                    name="value"
                    render={({ field: { onChange, value } }) => (
                      <CurrencyInput
                        value={value ?? 0}
                        fullWidth
                        variant="outlined"
                        size="small"
                        disabled={
                          suggestedValue !== 0 &&
                          !isOtherCorrespondenceServiceSelected &&
                          !isOtherDistrictSelected
                        }
                        className="inputSuggestionValue"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment sx={{ pl: 1 }} position="start">
                              R$
                            </InputAdornment>
                          ),
                        }}
                        onChange={(newValue) => {
                          // Mark as manually edited when user changes the value
                          setIsValueManuallyEdited(true);
                          onChange(newValue);
                        }}
                      />
                    )}
                  />
                  {errors.value && (
                    <span className="fieldError">
                      <ErrorIcon fontSize="inherit" />
                      {errors.value.message || 'Valor é obrigatório'}
                    </span>
                  )}
                </div>
                {correspondenceType !== CorrespondenceType.AUDIENCE && (
                <div>
                  <h2>Quem irá receber o serviço?</h2>
                  <div className="containerCheckbox">
                    <Controller
                      control={control}
                      name="isLawyer"
                      render={({ field: { value, onChange, ...rest } }) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={value || false}
                              onChange={(e) => onChange(e.target.checked)}
                              {...rest}
                            />
                          }
                          label=" Advogado"
                        />
                      )}
                    />
                    <Controller
                      control={control}
                      name="isRepresentative"
                      render={({ field: { value, onChange, ...rest } }) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={value || false}
                              onChange={(e) => onChange(e.target.checked)}
                              {...rest}
                            />
                          }
                          label=" Preposto"
                        />
                      )}
                    />
                  </div>
                </div>
                )}
                <div className="containerDataSolicitation">
                  <h2>Prazo de entrega do serviço</h2>
                  <div className="contentDate">
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                      <DesktopDatePicker
                        onError={() => setIsInvalidDate(!isInvalidDate)}
                        value={dateLimit}
                        onChange={(e) => handleSelectDate(e)}
                        minDate={new Date()}
                      />
                    </LocalizationProvider>
                    <div className="time">
                      <h3>Hora</h3>
                      <div className="dropdownTime">
                        <FormControl fullWidth>
                          <Select
                            classes={{ select: 'select-style' }}
                            onChange={(e) => {
                              setHourLimit(Number(e.target.value));
                            }}
                            value={hourLimit}
                            MenuProps={MenuProps}
                            displayEmpty
                            IconComponent={() => null}>
                            {Hour.map((hour) => (
                              <MenuItem value={hour} key={hour}>
                                {hour.toString().padStart(2, '0')}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <h2>:</h2>
                      {/* <CreatableSelect placeholder="mm" 
                      options={[{ label: 'Azul', value: 'teste' }]} 
                      formatCreateLabel={()=>"Adicionar"} 
                      onKeyDown={(e) => {
                        console.log(e.key)
                        if ((Number(e.key) < 0 && Number(e.key) > 9) || isNaN(Number(e.key))) {
                          e.preventDefault();
                        }
                      }}
                      onCreateOption={(e) => {
                        console.log(e)
                      }} /> */}
                      <div className="dropdownTime">
                        <FormControl fullWidth>
                          <Select
                            classes={{ select: 'select-style' }}
                            onChange={(e) => {
                              setMinutesLimit(Number(e.target.value));
                            }}
                            value={minutesLimit}
                            MenuProps={MenuProps}
                            displayEmpty
                            IconComponent={() => null}>
                            {Minutes.map((minute) => (
                              <MenuItem value={minute} key={minute}>
                                {minute.toString().padStart(2, '0')}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                  {isInvalidDate && (
                    <span className="fieldError">
                      <ErrorIcon fontSize="inherit" /> Data inválida
                    </span>
                  )}
                </div>

                <div id="attachmentAndObservations-item">
                  <div className="attachmentContainer">
                    <h2>Anexos</h2>
                    {user.type === TypeUser.USER && correspondenceId && (
                      <p className="attachmentDescriptions">
                        Arquivos necessários:{' '}
                        <span>
                          {correspondences
                            ?.find((c) => c.id === correspondenceId)
                            ?.attachmentTypes?.map(
                              (attType) => ATTACHMENT_TYPE_DESCRIPTIONS[attType],
                            )
                            .join(', ')}
                        </span>
                      </p>
                    )}
                    <div className="containerDropZone">
                      <DropZone
                        className="attachments-drop-zone"
                        type="attachments"
                        onFiles={(files) => setAttachments((prev) => [...prev, ...files])}
                        multipleFiles
                      />
                      <div className="attachment-list">
                        {attachments.map((att) => (
                          <Attachment
                            key={att.id}
                            options={{ disableDownload: true }}
                            data={{
                              name: att.file.name,
                              type: att.file.type,
                              uri: att.preview,
                              id: att.id,
                              file: att.file,
                            }}
                            onDelete={() => {
                              // Clean up the blob URL before removing
                              if (att.preview && att.preview.startsWith('blob:')) {
                                URL.revokeObjectURL(att.preview);
                              }
                              setAttachments((prev) => prev.filter((a) => a.id !== att.id));
                              // If it was an existing attachment, remove from existingAttachmentIds
                              if (att.id && existingAttachmentIds.includes(att.id)) {
                                setExistingAttachmentIds((prev) =>
                                  prev.filter((id) => id !== att.id),
                                );
                              }
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="noteContainer">
                    <h2>Observações</h2>
                    <Controller
                      control={control}
                      name="note"
                      render={({ field: { value, onChange, ...rest } }) => (
                        <textarea
                          value={value ?? ''}
                          onChange={onChange}
                          {...rest}
                          className="note"
                          maxLength={500}
                        />
                      )}
                    />
                  </div>
                </div>

                {/* {user.userType !== TypeUser.USER && (
                  <div style={{ display: 'flex' }}>
                    <Controller
                      control={control}
                      name="secrecy"
                      render={({ field: { onChange } }) => <ToggleSwitch onChange={onChange} />}
                    />
                  </div>
                )} */}
                {isEditMode && solicitationData && <EditHistory solicitation={solicitationData} />}
                <div className="containerButton">
                  <BasicButton
                    type="button"
                    variant="contained"
                    disabled={isRequesting}
                    onClick={handleSubmit(handleGenerateSolicitation, onError)}>
                    {isEditMode ? 'Atualizar Solicitação' : 'Gerar Solicitação'}
                  </BasicButton>
                </div>
              </div>
            </div>
          </div>
        </Body>
        {solicitation && matchSolicitation && (
          <ModalDuplicateSolicitation
            isOpen={isOpenModalDuplicateSolicitation}
            currentSolicitation={solicitation}
            matchSolicitation={matchSolicitation}
            onSelectOption={handleDiscartSolicitation}
            onRequestClose={() => setIsOpenModalDuplicateSolicitation(false)}
          />
        )}
        {isOpenConfirmTermModal && (
          <ModalAlertConfirmation
            isOpen={isOpenConfirmTermModal}
            data={{
              title: 'Atenção',
              text: `Antes de continuar, esteja ciente de que a plataforma LegalHub atua apenas como intermediadora entre os usuários e os prestadores de serviço.
              A LegalHub não se responsabiliza por eventuais problemas, fraudes ou falhas na execução dos serviços acordados entre as partes.
              Recomendamos que você tenha atenção redobrada ao negociar valores ou condições.
              Ao clicar em "Concordo", você declara estar ciente e de acordo com estas condições.`,
              type: 'warning',
              optionCancel: {
                text: 'Cancelar',
                active: true,
              },
              optionConfirm: {
                text: 'Concordo',
                active: true,
              },
            }}
            onRequestClose={() => setIsOpenConfirmTermModal(false)}
            onConfirm={handleSubmit(requestGenerateSolicitation, onError)}
          />
        )}
      </Container>
    </>
  );
}
